// extracted by mini-css-extract-plugin
module.exports = {"seo-block":"a10a3f92e9--seo-block--XWz9g","links":"a10a3f92e9--links--Drpdq"};